import VATValidator from '../../VATValidator'

export function taxIdIsValid(taxId: string): boolean {
  return VATValidator.isValid(taxId)
}
